<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h"><span>Praise for the Age of Unreason</span></p>
<p class="fm">“<i>Newton’s Cannon</i> features the classic elements of science fiction: high-tech gadgetry, world-threatening superpower conflict, a quest to save the world, and a teen hero who’s smarter than most of the adults. The historical setting gives this book something extra … Powerful.” —<i>USA Today</i></p>
<p class="fm">“Promises to follow honorably in the footsteps of [Orson Scott] Card’s <i>Alvin Maker</i> saga. Keyes knows his history, knows his science, and knows how to tell a story.” —<i>Booklist</i></p>
<p class="fm">“Masterful … A bravura performance … [An] ingenious mélange of Age of Unreason period details, stunning psychic and alchemical phenomena, [and] fetching poetic descriptions … Lavish and thoughtful.” —<i>Publishers Weekly</i>, starred review</p>
<p class="fm">“Inventive and exciting, filled with clever details and high adventure, [<i>The Shadows of God</i>] brings to a close a sequence that seems likely to establish Keyes as one of the more significant and original new fantasy writers to appear in recent years.” —<i>Science Fiction Chronicle</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?73cb4a96